import { render } from "./IconShowcase.vue?vue&type=template&id=e7090148"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconShowcase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7090148"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7090148', __exports__)) {
    api.reload('e7090148', __exports__)
  }
  
  module.hot.accept("./IconShowcase.vue?vue&type=template&id=e7090148", () => {
    api.rerender('e7090148', render)
  })

}


export default __exports__